import React from 'react';

const SvgInfo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M13.035 10.345v-2.12h-2.070v2.12h2.070zM13.035 18.775v-6.31h-2.070v6.31h2.070zM12 3q4.338 0 7.419 3.081t3.081 7.419-3.081 7.419-7.419 3.081-7.419-3.081-3.081-7.419 3.081-7.419 7.419-3.081z" />
  </svg>
);

export default SvgInfo;
